var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14848_2646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2L22 22",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.057 21.3421C12.4162 20.9829 12.6505 20.506 12.7467 19.9386C12.8429 19.3712 12.7991 18.7244 12.6177 18.0351C12.4363 17.3458 12.1209 16.6275 11.6895 15.9213C11.2581 15.215 10.7192 14.5346 10.1036 13.919C9.48789 13.3033 8.80751 12.7644 8.10126 12.333C7.39501 11.9016 6.67673 11.5863 5.98744 11.4049C5.29814 11.2235 4.65131 11.1796 4.0839 11.2758C3.51649 11.372 3.0396 11.6064 2.68045 11.9655L7.36873 16.6538L12.057 21.3421Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2976 7.00862L12.7871 8.34233L12.4095 8.67576",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.126 9.83704L15.8717 11.2777L15.5581 11.6379",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84106 17.1812L1.84106 22.1812",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9351 2.95799C14.6273 3.26582 14.4033 3.65149 14.276 4.09297C14.1487 4.53444 14.1205 5.02308 14.193 5.53099C14.2656 6.03889 14.4375 6.55612 14.6989 7.05313C14.9603 7.55014 15.3061 8.0172 15.7165 8.42765C16.127 8.8381 16.594 9.18389 17.091 9.4453C17.5881 9.7067 18.1053 9.87858 18.6132 9.95114C19.1211 10.0237 19.6097 9.99551 20.0512 9.86818C20.4927 9.74084 20.8783 9.51687 21.1862 9.20903L18.0607 6.08351L14.9351 2.95799Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14848_2646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.e415a70aad77d12eada2bdd140cb6ea0.svg";
export { ForwardRef as ReactComponent };